module.exports = __webpack_public_path__ + "img/yqltdnbanner.aa710b04.png";